module.exports = __webpack_public_path__ + "assets/images/rbyearend-08.jpg?v=3fb7d847";